import { Lookup } from './lookup.interface';

export interface EmploymentTypeLookup extends Lookup {
  requiresDescription?: boolean;
  requiresHours?: boolean;
}

export const AishEmploymentTypes: {
  [name: string]: EmploymentTypeLookup;
} = {
  fullTime: { code: 'fullTime', displayValue: 'Full-time', requiresHours: true },
  partTime: { code: 'partTime', displayValue: 'Part-time', requiresHours: true },
  selfEmployment: { code: 'selfEmployment', displayValue: 'Self-employment', requiresHours: true },
  seasonal: { code: 'seasonal', displayValue: 'Seasonal', requiresDescription: true },
  casual: { code: 'casual', displayValue: 'Casual', requiresDescription: true },
  temporary: { code: 'temporary', displayValue: 'Temporary', requiresDescription: true },
  onLeave: { code: 'onLeave', displayValue: 'On leave', requiresDescription: true },
  other: { code: 'other', displayValue: 'Other', requiresDescription: true },
};
